import { useTheme } from '@mui/material';

export const RealWorldEvidenceIcon = () => {
    const theme = useTheme();
    const { stroke } = theme.colors.other.icon;

    return (
        <svg
            width="49"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M6 8.89331C6.55228 8.89331 7 9.34103 7 9.89331V37.5433C7 38.0956 7.44772 38.5433 8 38.5433H39.25C39.8023 38.5433 40.25 38.991 40.25 39.5433C40.25 40.0956 39.8023 40.5433 39.25 40.5433H6C5.44772 40.5433 5 40.0956 5 39.5433V9.89331C5 9.34103 5.44772 8.89331 6 8.89331Z"
                fill={stroke.primary}
            />
            <path
                d="M23.3571 23.6362C23.7476 24.0268 23.7476 24.6599 23.3571 25.0505L19.2071 29.2005C18.8166 29.591 18.1834 29.591 17.7929 29.2005L15.9571 27.3647C15.5666 26.9741 14.9334 26.9741 14.5429 27.3647L10.7571 31.1505C10.3666 31.541 9.73342 31.541 9.3429 31.1505C8.95237 30.7599 8.95237 30.1268 9.3429 29.7362L14.5429 24.5362C14.9334 24.1457 15.5666 24.1457 15.9571 24.5362L17.7929 26.372C18.1834 26.7626 18.8166 26.7626 19.2071 26.372L21.9429 23.6362C22.3334 23.2457 22.9666 23.2457 23.3571 23.6362Z"
                fill={stroke.primary}
            />
            <path
                d="M27.9765 18.4552C28.367 18.8458 29.0002 18.8458 29.3907 18.4552L33.9869 13.8591C34.3774 13.4685 34.3774 12.8354 33.9869 12.4448C33.5964 12.0543 32.9632 12.0543 32.5727 12.4448L27.9765 17.041C27.586 17.4316 27.586 18.0647 27.9765 18.4552Z"
                fill={stroke.primary}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M36.9568 9.47496C40.0174 12.5357 40.2393 17.3601 37.6224 20.6766L41.8004 24.8545C42.1909 25.2451 42.1909 25.8782 41.8004 26.2688C41.4099 26.6593 40.7767 26.6593 40.3862 26.2688L36.2082 22.0908C32.8918 24.7076 28.0673 24.4857 25.0067 21.4251C21.7067 18.1251 21.7067 12.7749 25.0067 9.47496C28.3066 6.17503 33.6568 6.17503 36.9568 9.47496ZM35.5425 10.8892C38.0614 13.4081 38.0614 17.492 35.5425 20.0109C33.0237 22.5297 28.9397 22.5297 26.4209 20.0109C23.902 17.492 23.902 13.4081 26.4209 10.8892C28.9397 8.37029 33.0237 8.3703 35.5425 10.8892Z"
                fill={stroke.primary}
            />
        </svg>
    );
};
